import React from 'react'
import Layout from '../components/layout'
import pick from 'lodash/pick'
import get from 'lodash/get'
import contentfulClient from '../util/contentful-client'

export default class Experterna extends React.Component {
  state = {
    expertenTitle: '',
    expertenIngress: '',
    forfattarrubrik1: '',
    forfattartext1: '',
    forfattarrubrik2: '',
    forfattartext2: '',
    authorimageURL: '',
    authorimageAlt: '',
    author2imageURL: '',
    author2imageAlt: '',
    video1URL: '',
    video2URL: '',
    video3URL: '',
    video4URL: '',
    video5URL: '',
    posterOne: '',
    posterTwo: '',
    posterThree: '',
  }

  componentDidMount() {
    contentfulClient
      .getEntries({
        content_type: 'experten',
        limit: 1,
      })
      .then((entries) => {
        const entry = entries.items[0]

        const { expertenTitle } = entry.fields

        if (!entry) return

        console.log(entry.fields)

        const textFields = pick(entry.fields, [
          'expertenTitle',
          'forfattarrubrik1',
          'forfattartext1',
          'expertenIngress',
          'forfattarrubrik2',
          'forfattartext2',
        ])

        const video1URL = get(entry, 'fields.video1.fields.file.url', '')
        const video2URL = get(entry, 'fields.video2.fields.file.url', '')
        const video3URL = get(entry, 'fields.video3.fields.file.url', '')
        const video4URL = get(entry, 'fields.video4.fields.file.url', '')
        const video5URL = get(entry, 'fields.video5.fields.file.url', '')

        const authorimageURL = get(
          entry,
          'fields.forfattarbild1.fields.file.url',
          ''
        )
        const authorimageAlt = get(
          entry,
          'fields.forfattarbild1.fields.title',
          ''
        )

        const author2imageURL = get(
          entry,
          'fields.forfattarbild2.fields.file.url',
          ''
        )
        const author2imageAlt = get(
          entry,
          'fields.forfattarbild2.fields.title',
          ''
        )

        const posterOne = get(entry, 'fields.posterOne.fields.file.url', '')

        const posterTwo = get(entry, 'fields.posterTwo.fields.file.url', '')

        const posterThree = get(entry, 'fields.posterThree.fields.file.url', '')

        this.setState({
          ...textFields,
          expertenTitle,
          video1URL,
          video2URL,
          video3URL,
          video4URL,
          video5URL,
          authorimageURL,
          authorimageAlt,
          author2imageURL,
          author2imageAlt,
          posterOne,
          posterTwo,
          posterThree,
        })
      })
  }

  render() {
    return (
      <>
        <div className="row row-large">
          <h2 className="">{this.state.expertenTitle}</h2>
        </div>
        <div className="row row-small mb-2">
          <p className="intro-body is-bold">{this.state.expertenIngress}</p>
        </div>
        <div className="w-100">
          <div className="row row-large row-flex row-columns text-left">
            <div className="column-half mb-2">
              <img
                className="mb"
                src={this.state.author2imageURL}
                alt={this.state.author2imageAlt}
              />
              <h3 className="sub-heading">{this.state.forfattarrubrik2}</h3>
              <p>{this.state.forfattartext2}</p>
            </div>
            <div className="column-half mb-2">
              <video
                className="mb-2 w-100"
                controls
                src={this.state.video4URL}
              ></video>
              <video
                className="mb-2 w-100"
                controls
                src={this.state.video5URL}
              ></video>
            </div>
          </div>
          <div className="row row-large row-flex row-columns text-left">
            <div className="column-half mb-2">
              <img
                className="mb"
                src={this.state.authorimageURL}
                alt={this.state.authorimageAlt}
              />
              <h3 className="sub-heading">{this.state.forfattarrubrik1}</h3>
              <p>{this.state.forfattartext1}</p>
            </div>
            <div className="column-half mb-2">
              <video
                className="mb-2 w-100"
                controls
                src={this.state.video1URL}
                poster={this.state.posterOne}
              ></video>
            </div>
            <div className="column-half mb-2">
              <video
                className="mb-2 w-100"
                controls
                src={this.state.video2URL}
                poster={this.state.posterTwo}
              ></video>
            </div>
            <div className="column-half mb-2">
              <video
                className="mb-2 w-100"
                controls
                src={this.state.video3URL}
                poster={this.state.posterThree}
              ></video>
            </div>
          </div>
        </div>
      </>
    )
  }
}
